import { Component, OnInit } from '@angular/core';
import {PopinOneComponent} from '../popin-one/popin-one.component';
import {Data} from '../providers/data.provider';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-popin-visitor',
  templateUrl: './popin-visitor.component.html',
  styleUrls: ['./popin-visitor.component.scss']
})
export class PopinVisitorComponent implements OnInit {

  constructor(private data: Data,
              private route: ActivatedRoute,
              private router: Router) { }

  public visitRandomId: string;
  public uri: string;
  public customerName: string;
  public customerIdentifier: string;
  public customerCity: string;
  public customerActivity: string;
  public title1: string;
  public link1: string;
  public title2: string;
  public link2: string;
  public title3: string;
  public link3: string;

  ngOnInit(): void {
    this.visitRandomId = PopinOneComponent.visitRandomId;
    this.uri = encodeURIComponent(PopinOneComponent.uri);
    this.customerName = PopinOneComponent.customer.RaisonSociale;
    this.customerIdentifier = PopinOneComponent.customer.SIREN;
    this.customerCity = PopinOneComponent.customer.Ville;
    this.customerActivity = PopinOneComponent.customer.LibelleNAF;

    this.title1 = this.data.storage.visitorLinks.visitorTitle1;
    this.link1 = this.data.storage.visitorLinks.visitorLink1.replace(/[/]/g, '%2F');

    if (this.data.storage.visitorLinks.visitorLink2) {
      this.title2 = this.data.storage.visitorLinks.visitorTitle2;
      this.link2 = this.data.storage.visitorLinks.visitorLink2.replace(/[/]/g, '%2F');
    }
    if (this.data.storage.visitorLinks.visitorLink3) {
      this.title3 = this.data.storage.visitorLinks.visitorTitle3;
      this.link3 = this.data.storage.visitorLinks.visitorLink3.replace(/[/]/g, '%2F');
    }
  }

  redirectTo(link) {
    this.router.navigate([link], { queryParams: { visitRandomId: PopinOneComponent.visitRandomId }, relativeTo: this.route });
  }

}
